import React, { useState, useCallback } from 'react'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import context from '@/context'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { ModalBody, Label } from 'reactstrap'
import Resx from '@/components/Resx'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs/index'
import { useDispatch } from '@/hooks/dispatch'
import { IndividualSelector } from '@/components/individualSelector'

const AddIndividualDuplicate = React.memo(function AddIndividualDuplicity (props) {
  const { onAction } = props
  const [individualId, setIndividualId] = useState()
  const [secondIndividualId, setSecondIndividualId] = useState()
  const [openDialog] = useDispatch([
    dialogActions.openDialog
  ])

  const onIndividualChange = useCallback(({ value }) => {
    setIndividualId(value)
  }, [setIndividualId])

  const onSecondIndividualChange = useCallback(({ value }) => {
    setSecondIndividualId(value)
  }, [setSecondIndividualId])

  const onConfirm = useCallback(() => {
    context.api.dataCrossingService.areIndividualsCompared({ id: individualId, secondId: secondIndividualId })
      .then(response => {
        if (response.areIndividualsCompared) {
          if (response.isSameIndividual) {
            openDialog({
              dialogType: dialogTypes.alert,
              title: 'DataCrossings.AlreadyDuplicateTitle',
              content: 'DataCrossings.AlreadyDuplicate'
            })
          } else {
            openDialog({
              dialogType: dialogTypes.confirm,
              title: 'DataCrossings.AlreadyNotDuplicateTitle',
              content: 'DataCrossings.AlreadyNotDuplicate',
              onAction: () => {
                if (individualId !== secondIndividualId) {
                  onAction({ individualId, secondIndividualId })
                }
              }
            })
          }
        } else {
          onAction({ individualId, secondIndividualId })
        }
      })
      .catch(() => {
        openDialog({
          dialogType: dialogTypes.alert,
          content: 'DataCrossings.CheckDuplicateError'
        })
      })
  }, [individualId, secondIndividualId, onAction, openDialog])

  const onFirstIndividualPairValidation = useCallback(({ value }) => {
    if (value === secondIndividualId) {
      return 'DataCrossings.SelectedSameIndividualError'
    }
  }, [secondIndividualId])

  const onSecondIndividualPairValidation = useCallback(({ value }) => {
    if (value === individualId) {
      return 'DataCrossings.SelectedSameIndividualError'
    }
  }, [individualId])

  return (
    <ValidationBoundary>
      <BasicHeader title='' {...props} />
      <ModalBody>
        {!props.onlySecondIndividualSelection &&
        <React.Fragment>
          <Label><Resx name='DataCrossings.Individual' /></Label>
          <Validator name='individual' value={individualId} onValidate={onFirstIndividualPairValidation} required>
            <IndividualSelector
              dataSource={context.api.individualService.getIndividualsForDuplicityList}
              onChange={onIndividualChange}
              value={individualId} />
          </Validator>
        </React.Fragment>
        }
        <Label><Resx name='DataCrossings.DuplicateIndividual' /></Label>
        <Validator name='secondIndividual' value={secondIndividualId} onValidate={onSecondIndividualPairValidation} required>
          <IndividualSelector
            dataSource={context.api.individualService.getIndividualsForDuplicityList}
            onChange={onSecondIndividualChange}
            value={secondIndividualId} />
        </Validator>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter {...props} onAction={onConfirm} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
})

export default {
  component: AddIndividualDuplicate
}



// WEBPACK FOOTER //
// ./src/dialogs/addIndividualDuplicate.js